import {enableProdMode, provideZoneChangeDetection} from '@angular/core';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {format} from 'date-fns';
//@ts-ignore
import * as Handlebars from 'handlebars/dist/cjs/handlebars';
import {loadDevMessages, loadErrorMessages} from '@apollo/client/dev';
import {platformBrowser} from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
} else {
  loadDevMessages();
  loadErrorMessages();
}

platformBrowser().bootstrapModule(AppModule, {applicationProviders: [provideZoneChangeDetection()],})
  .catch(err => console.error(err));

Handlebars.registerHelper('toDate', function(dateStr: string, dateFmt: string) {
  return format(new Date(dateStr), dateFmt);
});


